const Support = () => {
  return (
    <div className='container'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='mt-5 mb-4'>Support</h3>
          <h5>Blast It All      </h5>
          <p>
            
1090 Atlantic Drive, West Chicago, Illinois, 60185, USA
          </p>
        </div>
      </div>
    </div>
  );
};

export default Support;
